/**
 * Normalisation des statuts → 5 valeurs UI communes (`DiffusionStatus`).
 *
 * MIROIR TS de la logique SQL de la VIEW `v_diffusions` (migration 0143).
 * - vidéo : `social_publications.status` (enum youtube_video_status) + `scheduled_at`
 *   (« programmé » = `draft` avec une échéance future — le worker ignore les draft).
 * - blog : `blog_social_posts.status` (idle/scheduled/posting/posted/failed).
 */

import type { DiffusionStatus } from './types';

export type VideoPubStatus =
  | 'draft'
  | 'queued'
  | 'rendering'
  | 'encoding'
  | 'uploading'
  | 'published'
  | 'failed';

export type BlogPostStatus = 'idle' | 'scheduled' | 'posting' | 'posted' | 'failed';

/** Statut normalisé d'une publication vidéo (`social_publications`). */
export function normalizeVideoStatus(
  status: VideoPubStatus,
  scheduledAt: string | null,
  now: Date = new Date(),
): DiffusionStatus {
  if (status === 'draft') {
    if (scheduledAt && new Date(scheduledAt).getTime() > now.getTime()) return 'scheduled';
    return 'draft';
  }
  if (status === 'published') return 'published';
  if (status === 'failed') return 'failed';
  // queued | rendering | encoding | uploading
  return 'publishing';
}

/** Statut normalisé d'un post blog (`blog_social_posts`, null = slot pas encore créé). */
export function normalizeBlogStatus(status: BlogPostStatus | null | undefined): DiffusionStatus {
  switch (status) {
    case 'scheduled':
      return 'scheduled';
    case 'posting':
      return 'publishing';
    case 'posted':
      return 'published';
    case 'failed':
      return 'failed';
    case 'idle':
    case null:
    case undefined:
    default:
      return 'draft';
  }
}

/** Une diffusion est-elle actionnable (programmable / publiable maintenant) ? */
export function isActionable(status: DiffusionStatus): boolean {
  return status === 'draft' || status === 'scheduled' || status === 'failed';
}
